import React, { useEffect, useState } from 'react';

import { JWT, USER_COUNTRY_NAME } from 'apps/auth/constants/Constants';
import { useAuth } from 'apps/auth/hooks/selectors';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const WSChat = () => {
    const { jwt: authJwt, userCountryName: authUserCountryName } = useAuth();
    const countryFieldId = '5256111385885';

    const [clientAuth, setClientAuth] = useState(null);

    useEffect(() => {
        const url = new URL(window.location.href);
        setClientAuth({
            jwt: cookies.get(JWT) || url.searchParams.get('token'),
            userCountryName: cookies.get(USER_COUNTRY_NAME),
        });
    }, []);

    const jwt = authJwt || clientAuth?.jwt;
    const userCountryName = authUserCountryName || clientAuth?.userCountryName;

    const initChatWidget = () => {
        if (typeof zE === 'function' && jwt) {
            zE('messenger', 'loginUser', function (callback) {
                callback(jwt);
            });

            if (userCountryName) {
                zE('messenger:set', 'conversationFields', [{ id: countryFieldId, value: userCountryName }]);
            }
        }
    };

    useEffect(() => {
        if (__isBrowser__) {
            if (document.readyState === 'complete') {
                initChatWidget();
            } else {
                window.addEventListener('load', initChatWidget, { once: true });
            }
        }

        return () => {
            window.removeEventListener('load', initChatWidget);
        };
    }, [jwt]);

    return !jwt ? <div id="ze-snippet" /> : null;
};

export default WSChat;
